import { ElementType } from 'react';

import { Paper, styled } from '@mui/material';
import { omitForwardedProps } from 'common/utils';

type Props = {
  inset?: boolean;
  dense?: boolean;
  background?: 'transparent' | 'white';
} & { component?: ElementType };

export const Wrapper = styled(Paper, {
  name: 'Section',
  shouldForwardProp: omitForwardedProps<Props>('dense', 'inset', 'background'),
})<Props>(({ theme: { spacing, shape }, dense, inset = true, background = 'white' }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: dense ? spacing(2) : spacing(3),
  borderRadius: dense ? shape.borderRadius : shape.borderRadius * 2,
  background,

  ...(inset
    ? {
        padding: spacing(3),
      }
    : {
        border: 'none',
      }),
}));
